import React from 'react';
import PropTypes from 'prop-types';

import {
    IconMail,
    IconPhoneCircle,
    Paragraph,
    TextButton,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import ListCell from 'app/shared/components/ListCell';

import { CenteredSpacer, StyledHeading } from '../../StyledComponents';

const propTypes = {
    onHelpClick: PropTypes.func.isRequired,
    onContactMethodLookup: PropTypes.func.isRequired,
};

const defaultProps = {};

const ChooseMethod = ({
    onHelpClick,
    onContactMethodLookup,
}) => {
    const renderAdditionalLinks = () => (
        <CenteredSpacer marginTop={6.5} marginBottom="xl">
            <Paragraph marginBottom="xs">
                Need more information?
            </Paragraph>
            <TextButton fontType="body" onClick={onHelpClick}>See our help article</TextButton>
        </CenteredSpacer>
    );

    return (
        <Row>
            <Col md={2} />
            <Col xs={12} md={8}>
                <CenteredSpacer marginTop="sm" marginBottom="sm">
                    <StyledHeading>
                        You&apos;ll need access to the listing contact email or phone number for verification
                    </StyledHeading>
                </CenteredSpacer>
                <ListCell
                    icon={<IconPhoneCircle fontColor="blue600" size="md" />}
                    primaryText="Phone"
                    secondaryText="Find listings using your contact phone number"
                    ctaIcon={true}
                    onHeaderClick={() => onContactMethodLookup('phone')}
                />
                <ListCell
                    addBorderBottom={true}
                    icon={<IconMail fontColor="blue600" size="md" />}
                    primaryText="Email"
                    secondaryText="Find listings using your contact email"
                    ctaIcon={true}
                    onHeaderClick={() => onContactMethodLookup('email')}
                />
                {false && renderAdditionalLinks()}
            </Col>
            <Col md={2} />
        </Row>
    );
};

ChooseMethod.propTypes = propTypes;
ChooseMethod.defaultProps = defaultProps;

export default ChooseMethod;
